import React, { Component } from 'react';
import { CheckIcon, ChevronRightIcon } from '@heroicons/react/outline';
import { FormattedMessage } from 'react-intl';
import Toast from '../controls/BaseToast';
import authService from '../api-authorization/AuthorizeService'
import { AuthorityModules, AuthorityActions } from '../api-authorization/ApiAuthorizationConstants';
import { AccountGroup } from '../infrastructure/AppConstants';

export class StepPanel extends Component {
    static displayName = StepPanel.name;

    constructor(props) {
        super(props);
        this.state = { currentStep: props.currentStep, model: props.model, isAllowSubmit: true, isDigitalizedFileRequired:false };
        this.handleBack = this.handleBack.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleOnlySave = this.handleOnlySave.bind(this);
        this.handleReview = this.handleReview.bind(this);
    }
    handleCancel(e) {
        e.preventDefault();
        window.history.back(-1);
    }

    handleSave(e) {
        e.preventDefault();

        var handle = this.props.onSave;
        if (handle) {
            handle();
        }
    }
    handleReview(e) {
        e.preventDefault();
        this.props.onReview && this.props.onReview(this.state.isDigitalizedFileRequired);

    }
    handleOnlySave(e) {
        this.props.onOnlySave && this.props.onOnlySave();
    }
    handleBack(e) {
        e.preventDefault();
        const oldStep = this.state.currentStep;
        let newStep = oldStep - 1;
        var handle = this.props.onBack;
        if (handle) {
            handle(oldStep, newStep);
        }
        this.setState({ currentStep: newStep });
    }

    handleNext(e) {
        e.preventDefault();
        let oldStep = this.state.currentStep;
        var ref = this.props.stepRefs[oldStep];
        var result = ref.current.validate();
        if (!result.state) {
            Toast.warn(result.msg);
            return;
        }
        else {
            //alert(result.msg);
        }

        let newStep = this.state.currentStep + 1;
        var handle = this.props.onNext;
        if (handle) {
            handle(oldStep, newStep);
        }
        this.setState({ currentStep: newStep });
        if (this.props.stepHeaders.length - 2 == newStep) {
            this.isAllowSubmit();
        }
       
    }

    handleFinish(e) {
        e.preventDefault();
        let curStep = this.state.currentStep;
        var ref = this.props.stepRefs[curStep];
        var result = ref.current.validate();
        if (!result.state) {
            Toast.warn(result.msg);
            return;
        }
        else {
            //alert(result.msg);
        }
        var handle = this.props.onFinish;
        if (handle) {
            handle();
        }
    }

    renderButtons(currentStep, steps, isAllowSubmit, attachFile) {
        if (currentStep == 0) {
            return <div className="flex gap-2 justify-start">
                <button className="inline-block mx-2 py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" onClick={this.handleCancel}><FormattedMessage id="Back" /></button>
                <button className="inline-block mx-2 py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" onClick={this.handleSave}><FormattedMessage id="Save" /></button>
                <button className="inline-block mx-2 py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" onClick={this.handleNext}><FormattedMessage id="NextStep" /></button>
                <a className="inline-block mx-2 py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" href={window.location.href + "?preview=1"} onClick={this.handleOnlySave} target="_blank"><FormattedMessage id="Preview" /></a>
            </div>;
        }
        else if (currentStep == steps - 1) {
            return <div className="flex gap-2 justify-start">
                <button className="inline-block mx-2 py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" onClick={this.handleCancel}><FormattedMessage id="Back" /></button>
                <button className="inline-block mx-2 py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" onClick={this.handleSave}><FormattedMessage id="Save" /></button>
                <button className="inline-block mx-2 py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" onClick={this.handleBack}><FormattedMessage id="PreviousStep" /></button>
                {isAllowSubmit ? (< button className="inline-block mx-2 py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" onClick={this.handleFinish}><FormattedMessage id="Submit" /></button>) : (< button className="inline-block mx-2 py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" onClick={this.handleReview}><FormattedMessage id="SubmitReview" /></button>)}
                <a className="inline-block mx-2 py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" href={window.location.href + "?preview=1"} onClick={this.handleOnlySave} target="_blank"><FormattedMessage id="Preview" /></a>
                {attachFile.map((item, index) => {
                    return (<a key={index} className="mr-5 text-blue-600 text-sm" href={item}>{index + 1}.  {
                        (item.indexOf("?sv") > -1 ? item.substring(item.lastIndexOf('/') + 1, item.indexOf("?sv")) : item.substring(item.lastIndexOf('/') + 1))}</a>)
                })}

            </div>;

        }
        else {
            return <div className="flex gap-2 justify-start">
                <button className="inline-block mx-2 py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" onClick={this.handleCancel}><FormattedMessage id="Back" /></button>
                <button className="inline-block mx-2 py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" onClick={this.handleSave}><FormattedMessage id="Save" /></button>
                <button className="inline-block mx-2 py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" onClick={this.handleBack}><FormattedMessage id="PreviousStep" /></button>
                <button className="inline-block mx-2 py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" onClick={this.handleNext}><FormattedMessage id="NextStep" /></button>
                <a className="inline-block mx-2 py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" href={window.location.href + "?preview=1"} onClick={this.handleOnlySave} target="_blank"><FormattedMessage id="Preview" /></a>
            </div>;
        }
    }

     isAllowSubmit() {
        const dealer = this.state.model.dealerInfo;
        const accountGroup = authService.getCurrentUser().accountGroup;
        authService.isAllow(AuthorityModules.Order, AuthorityActions.Edit).then(isAllowEdit => {
            authService.getAccessToken().then(token => {
                fetch('dealer/GetDeliverAccountCodesWithDealerId?page=0&dealerId=' + dealer.id + "&keyword=" + dealer.deliverAccountCode, {
                    headers: !token ? {} : { 'Authorization': `${token}` }
                }).then(response => response.json())
                    .then(data => {
                        this.setState({ isAllowSubmit: (isAllowEdit && (data.entities[0].isSubmitByDealerAdmin && AccountGroup.DealerAdmin == accountGroup) || (!data.entities[0].isSubmitByDealerAdmin)), isDigitalizedFileRequired: data.entities[0].isDigitalizedFileRequired })
                });
            })

        });
    }
    render() {
        const stepHeaders = this.props.stepHeaders;
        const stepSubTitles = this.props.stepSubTitles;
        const stepContents = this.props.stepContents;
        const currentStep = this.state.currentStep;
        const isAllowSubmit = this.state.isAllowSubmit;
        var attachFile = [];
        const accountGroup = authService.getCurrentUser().accountGroup;
        if (this.props.model.attachmentFile && accountGroup == AccountGroup.DealerAdmin) {
            attachFile = this.props.model.attachmentFile.split(',');
        }
        return (
            <div className="px-4 py-0">
                <div className={"bg-white my-4 gap-x-4 rounded-lg px-6 border-2 border-gray-200 " + "grid grid-cols-" + stepHeaders.length}>
                    {
                        stepHeaders.map(function (s, index) {

                            if (index < currentStep) {
                                return <div className="flex justify-between items-center h-10">
                                    <div className="bg-indigo-500 h-8 w-8 text-white text-center font-extrabold flex items-center justify-center rounded-full"><CheckIcon /></div>
                                    <div><label><FormattedMessage id={s} /></label></div>
                                    <div className="w-6 text-gray-400"><ChevronRightIcon /></div>
                                </div>
                            }
                            else if (index === currentStep) {
                                return <div className="flex justify-between  text-indigo-600 items-center h-10">
                                    <div className="border-2 border-indigo-500 h-8 w-8  text-center font-extrabold flex items-center justify-center rounded-full">{index + 1}</div>
                                    <label><FormattedMessage id={s} /></label>
                                    <div className="w-6 text-gray-400"><ChevronRightIcon /></div>
                                </div>
                            }
                            else {
                                if (index == stepHeaders.length - 1) {
                                    return <div className="flex justify-between text-gray-500 items-center h-10">
                                        <div className="border-2 border-gray-400 h-8 w-8  text-center font-extrabold flex items-center justify-center rounded-full">{index + 1}</div>
                                        <label><FormattedMessage id={s} /></label>
                                        <div></div>
                                    </div>
                                }
                                else {
                                    return <div className="flex justify-between text-gray-500 items-center h-10">
                                        <div className="border-2 border-gray-400 h-8 w-8  text-center font-extrabold flex items-center justify-center rounded-full">{index + 1}</div>
                                        <label><FormattedMessage id={s} /></label>
                                        <div className="w-6 text-gray-400"><ChevronRightIcon /></div>
                                    </div>
                                }
                            }
                        }
                        )
                    }
                </div>
                <div className="hidden sm:block" aria-hidden="true">
                    <div className="py-2">
                        <div className="border-t border-gray-200" />
                    </div>
                </div>
                <div className="mt-10 sm:mt-0">
                    <div className="">
                        <div className="md:col-span-1">
                            <div className="px-4 sm:px-0">
                                <h3 className="text-lg font-medium leading-6 text-gray-900"><FormattedMessage id={stepHeaders[currentStep]} /></h3>
                                <p className="mt-0 text-sm text-gray-600"><FormattedMessage id={stepSubTitles[currentStep]} /></p>
                            </div>
                        </div>
                        <div className="mt-2 md:mt-2 md:col-span-2">
                            <div className="shadow overflow-hidden sm:rounded-md">
                                <div className="px-4 py-5 bg-white sm:p-6">
                                    {stepContents[currentStep]}
                                </div>
                                <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                                    {this.renderButtons(currentStep, stepHeaders.length, isAllowSubmit, attachFile)}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

